import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { DialogService } from 'primeng/dynamicdialog';
import { VerifySaleAuthService } from '@core/services/verify-sale-auth.service';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    ButtonModule,
    AppRoutingModule, 
    HttpClientModule,
  ],
  exports: [
    AppRoutingModule
  ],
  providers: [DialogService, VerifySaleAuthService], 
  bootstrap: [AppComponent]
})
export class AppModule { }
